import Backbone from 'backbone';

import {MultiEmailValidator} from 'sma.common/validators';

let Loader = require('sma.admin/components/loader');
let modals = require('sma.common/components/modals');

var baseTemplate = require('sma.applicant/components/collaborators/partials/base.mustache');
var collaboratorRow = require('sma.applicant/components/collaborators/partials/collaborator_row.mustache');

class BaseCollaboratorModal extends Backbone.View {
	get events() {
		return {
			'input #invite-collaborators-email': 'inviteCollaboratorsInputHandler',
			'click .remove-collaborator': 'removeCollaborator',
			'change .existing-collaborator-permissions': 'modifyCollaborator',
			'click .resend-invite': 'resendInvite',
		};
	}

	/**
	 * Initialize context and initiate building the collaborator modal
	 * 
	 * @param  {int} - application id
	 */
	initialize(context) {
		this.isTask = context.isTask;
		this.applicationId = context.applicationId;
		this.isAppOwner = context.isOwner;
		this.isViewer = context.isViewer;
		this.defaultPermissionIsViewer = context.defaultPermissionIsViewer;
		this.defaultPermissionIsEditor = context.defaultPermissionIsEditor;

		if(context.defaultPermission) {
			this.defaultPermission = context.defaultPermission;
		}

		// Different views (types of content within the modal)
		this.collaboratorViews =  {
			INVITE_COLLABORATORS: 1,
			LIST_COLLABORATORS: 2,
		};

		var includeOwner = context.includeOwner ? context.includeOwner : false

		// Before builing the modal lets see if we have any collaborators
		this.getCollaborators(includeOwner);
	}

	/*-------------------------------------			
	/*      		EVENTS
	/*-------------------------------------

	/**
	 * Orchestrates what content is to be shown in the modal
	 * 
	 * @param  {email input field}
	 */
	inviteCollaboratorsInputHandler(e) {
		var value = $(e.target).val();

		if(!this.isTask) {
			value ? this.showInviteView() : this.showCollaboratorView();
		}

		if(value) {
			let validator = new MultiEmailValidator({
				$el: $(e.target),
				$disableElements: $(this.modal.modalFooter.find('.send-collaborator-invite')),
			});

			validator.validate();
		} else {
			$(e.target).removeClass('form-control-danger').removeClass('form-control-success');
		}
	}

	/**
	 * Sends the invited collaborators an invitation email  
	 * 
	 * @param  {Send invite button}
	 */
	sendInvite(e) {
		var emails = this.$el.find('#invite-collaborators-email').val().replace(/ /g, '').split(",");
		var permission = this.$el.find('.collaborator-permissions').val();
		var message = this.$el.find('#invite-collaborators-message').val();

		this.loader = new Loader(this.modal.modalWindow);
		this.loader.show();

		sma.applicants.components.ajax.post({
			url: reverse('collaborator-email-invite', {
				app_id: this.applicationId,
			}),
			data: {'emails': emails, 'permission': permission, 'message': message},
			callback: $.proxy(function() {
				this.postSendInvite();
			}, this)

		});
	}

	postSendInvite() {
		new sma.applicants.detail.CollaboratorAvatars(this.applicationId);
		this.loader.hide();
		this.modal.hide();
	}

	/**
	 * Removes the collaborator when the remove button is clicked
	 * 
	 * @param  {button} e
	 */
	removeCollaborator(e) {
		var collaboratorRow = $(e.target.closest(".collaborator-row"));
		var collaboratorEmail = $(collaboratorRow.find(".collaborator-email")).text();
		
		sma.applicants.components.ajax.post({
			url: reverse('delete-collaborator', {
				app_id: this.applicationId,
			}),
			data: {"email": collaboratorEmail},
			callback: $.proxy(function() {
				collaboratorRow.remove();
				this.postCollaboratorRemove();
			}, this)
		});
	}

	postCollaboratorRemove() {}

	/**
	 * Modifies the collaborator when the permissions drop down is changed
	 * 
	 * @param  {dropselect} e
	 */
	modifyCollaborator(e) {
		var collaboratorRow = $(e.target.closest(".collaborator-row"));
		var collaboratorEmail = $(collaboratorRow.find(".collaborator-email")).text();

		sma.applicants.components.ajax.post({
			url: reverse('modify-collaborator', {
				app_id: this.applicationId,
			}),
			data: {"email": collaboratorEmail, "permission": $(e.target).val()},
			callback: $.proxy(function() {
				new sma.applicants.detail.CollaboratorAvatars(this.applicationId);
			}, this)
		});
	}

	/**
	 * When resend invite is clicked populate the invite email field and change views. 
	 * The reason we don't send the email directly is incase the user wants to write an 
	 * optional message. 
	 * 
	 * @param  {resent invite link} e
	 */
	resendInvite(e) {
		var collaboratorRow = $(e.target.closest(".collaborator-row"));
		var collaboratorEmail = $(collaboratorRow.find(".collaborator-email")).text();

		this.$el.find('#invite-collaborators-email').val(collaboratorEmail);
		this.showInviteView();
	}

	/*-------------------------------------			
	/*      		HELPERS
	/*-------------------------------------

	/**
	 * Given a list of collaborators, build the collaborator rows.
	 * 
	 * @param  {refined Collaborator objects}
	 */
	buildCollaboratorRows(collaborators) {
		var renderedCollaborators = [];

		// For each collaborator, build the row and set initial values. 
		$.each(collaborators, (i, el) => {
			el['isAppOwner'] = this.isAppOwner;
			el['returnUrl'] = reverse('application-dashboard');

			var rendered = $(collaboratorRow(el));

			var dropSelect = $('.custom-select:first', rendered);

			dropSelect.find('option[value="' + el.permission + '"]').attr('selected', 'selected').end();

			renderedCollaborators.push(rendered[0].outerHTML);
 		});

		// Build the modal with the rendered collaborator rows
		this.buildCollaboratorModal(renderedCollaborators); 
	}

	/**
	 * Given the rendered collaborator rows, build the collaborator modal
	 * 
	 * @param  {html} rendered_collaborators - rendered collaborator rows
	 */
	buildCollaboratorModal(renderedCollaborators) {
		var context = {
			'renderedCollaborators': renderedCollaborators,
			'isAppOwner': this.isAppOwner,
			'isViewer': this.isViewer,
			'defaultPermission': this.defaultPermission,
			'defaultPermissionIsEditor': this.defaultPermissionIsEditor,
			'defaultPermissionIsViewer': this.defaultPermissionIsViewer,
		}
		
		var content = $(baseTemplate(context)); 

		this.modal = new modals.ContentModal(
			content, {
				title: 'Collaborators',
				size: 'md',
				buttons: [{
					label: gettext('Send Invite'),
					cls: 'btn btn-default send-collaborator-invite',
					handler: (modal) => {
						this.sendInvite();
					}
				}]
			}
		)
		this.modal.show();

		this.setElement(this.modal.modalWindow);		

		// Initial view
		if(this.isTask) {
			this.currentView = this.collaboratorViews.INVITE_COLLABORATORS;
			this.showInviteView();
		} else {
			this.currentView = this.collaboratorViews.LIST_COLLABORATORS;
			this.showCollaboratorView();
		}
	}

	/**
	 * Shows/hides neccessary components for the collaborator invite content
	 */
	showInviteView() {
		this.modal.modalFooter.show();
		this.modal.modalBody.find('.collaborator-list').hide();
		this.modal.modalBody.find('.collaborator-message').show();
	}

	/**
	 * Shows/hides neccessary components for the collaborator list content
	 */
	showCollaboratorView() {
		this.modal.modalFooter.hide();
		this.modal.modalBody.find('.collaborator-message').hide();
		this.modal.modalBody.find('.collaborator-list').show();
	}

	/**
	 * GET all collaborators on the application
	 */
	getCollaborators(includeOwner) {
		var collaborators = [];

		sma.applicants.components.ajax.get({
			url: reverse('get-collaborators', {
				app_id: this.applicationId,
			}),
			data: {
				includeOwner: includeOwner,
			},
			callback: $.proxy(function(collaborators) {
				// Build the rows with the newly retrieved collaborators
				this.buildCollaboratorRows(collaborators);
			}, this)
		});
	}
}

module.exports = {
	BaseCollaboratorModal: BaseCollaboratorModal,
}
